export const normalizeImagePath = (path) => {
  if (!path) return '';
  if (path.startsWith('./img/')) return path.replace('./img/', '/img/');
  if (path.startsWith('./')) return path.replace('./', '/');
  return path;
};
